// SPDX-License-Identifier: GPL-3.0-only
/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/CLASSNAMES
 *
 * @description
 * ## Some CSS classnames used in the app
 */


//export const MAIN = "main";
//
export const HIDDEN = "hidden";

export const GAME = "pd-game";

//export const PRELOAD_FONT = "preload-font";
//
//export const OVER_CONTROL_AREA = "over-control-area";
//export const OVER_CLICKABLE_AREA = "over-clickable-area";
